import React, { FC } from 'react';

import { Loader2 } from 'lucide-react';

type IProps = {
    innerText: string;
    isLoading: boolean;
    disabled?: boolean;
    onClick: () => void;
    id?: string;
    className?: string;
};

const ButtonLoader: FC<IProps> = ({ innerText, isLoading, onClick, id, disabled, className }) => {
    return (
        <button
            onClick={onClick}
            type="button"
            disabled={isLoading || disabled}
            id={id}
            className={`btn ${className} flex h-10 w-full  items-center justify-center border-custom-500 bg-custom-500 text-white hover:border-custom-600 hover:bg-custom-600 hover:text-white focus:border-custom-600 focus:bg-custom-600 focus:text-white focus:ring focus:ring-custom-100 active:border-custom-600 active:bg-custom-600 active:text-white active:ring active:ring-custom-100 dark:ring-custom-400/20`}
        >
            {isLoading ? <Loader2 className="size-4 animate-spin ltr:mr-2 rtl:ml-2" /> : innerText}
        </button>
    );
};

export default ButtonLoader;
